import * as React from "react"
import { Color } from "types/bootstrap"
import BroadcastChannel from "broadcast-channel"
import { useSyncedReducer } from "hooks"

const channel = new BroadcastChannel<Action>("toast")

export interface ToastData {
	header: string
	text: string
	icon: Color | React.ComponentType
}

interface Toast extends ToastData {
	id: string
}

interface ToastContext extends Toast {
	open: boolean
}

export const ToastContext = React.createContext<ToastContext[]>([])
export const ToastContextSetState = React.createContext<React.Dispatch<Action>>(
	() => {}
)

export type Action =
	| { type: "add"; payload: Toast }
	| { type: "hide"; id: string }
	| { type: "delete"; id: string }

const reducer = (state: ToastContext[], action: Action) => {
	switch (action.type) {
		case "add":
			return [...state, { open: true, ...action.payload }]
		case "hide":
			return state.map((item) => {
				if (item.id === action.id) {
					return { ...item, open: false }
				}
				return item
			})
		case "delete":
			return state.filter((item) => item.id !== action.id)
		default:
			throw new Error("Unexpected action")
	}
}

const ToastProvider: React.FC = ({ children }) => {
	const [state, dispatch] = useSyncedReducer(channel, reducer, [])
	return (
		<ToastContextSetState.Provider value={dispatch}>
			<ToastContext.Provider value={state}>
				{children}
			</ToastContext.Provider>
		</ToastContextSetState.Provider>
	)
}

export default ToastProvider
